export default "__VITE_ASSET__Y7pMGLJv__"